import debounce from 'lodash/debounce'
import React, { useEffect, useState } from 'react'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import Colors from '../../../assets/styles/Colors'
import Title from '../../../components/v2/Title'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../store'
import { HealthState, setPriceRanges, setSelectedPackageServices } from '../../../store/healthSlice'
import Loader from '../../../components/Loader'
import HealthServiceIcon from '../../../assets/v2/JSX/HealthServiceIcon'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import HealthProgressbar from '../../../components/v2/progrees-bars/HealthProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AppState } from '../../../store/appSlice'

const HealthCompareCompanies = () => {
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //

  //fake data
  const healthPackageServices = {
    id: 16,
    createdAt: '2023-10-27T13:44:35.435+04:00',
    updatedAt: '2023-10-27T13:44:35.435+04:00',
    translations: {
      ge: {
        title: 'Which One?',
        stepName: 'რომელი პაკეტი?',
      },
      en: {
        title: 'Which One?',
        stepName: 'Which One?',
      },
    },
    listItems: [
      {
        id: 38,
        listId: 16,
        sort: 1,
        type: '44-100 ₾',
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: '44-55 ₾/თვე',
          },
          en: {
            title: '44-55 ₾/mo',
          },
        },
        createdAt: '2023-10-27T13:44:35.447+04:00',
        updatedAt: '2023-10-27T13:44:35.447+04:00',
        title: '44-55 ₾',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. Lorem Ipsum has been that  industry’s standard  dummy text ever since the, when an unknown aren me of company printer took a galley.',
        services: {
          ambulatory: {
            limit: '40-100 %',
            payment: '1000-1500',
          },
          medicines: {
            limit: '40-60 %',
            payment: '500-1500',
          },
          hospitalization: {
            limit: '40-100 %',
            payment: '3000-15000',
          },
          dentistry: {
            limit: '50-100 %',
            payment: '500-1000',
          },
        },
      },
      {
        id: 39,
        listId: 16,
        sort: 2,
        type: '44-100 ₾',
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: '55-75 ₾/თვე',
          },
          en: {
            title: '55-75 ₾/mo',
          },
        },
        createdAt: '2023-10-27T13:44:35.447+04:00',
        updatedAt: '2023-10-27T13:44:35.447+04:00',
        title: '55-75 ₾',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. Lorem Ipsum has been that  industry’s standard  dummy text ever since the, when an unknown aren me of company printer took a galley.',
        services: {
          ambulatory: {
            limit: '50-100 %',
            payment: '600-2500',
          },
          medicines: {
            limit: '50-70 %',
            payment: '600-2500',
          },
          hospitalization: {
            limit: '40-100 %',
            payment: '4000-17000',
          },
          dentistry: {
            limit: '60-100 %',
            payment: '1200-1500',
          },
        },
      },
      {
        id: 40,
        listId: 16,
        sort: 3,
        type: '44-100 ₾',
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: '76-100 ₾/თვე',
          },
          en: {
            title: '76-100 ₾/mo',
          },
        },
        createdAt: '2023-10-27T13:44:35.448+04:00',
        updatedAt: '2023-10-27T13:44:35.448+04:00',
        title: '76-100 ₾',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. Lorem Ipsum has been that  industry’s standard  dummy text ever since the, when an unknown aren me of company printer took a galley.',
        services: {
          ambulatory: {
            limit: '50-100 %',
            payment: '600-3000',
          },
          medicines: {
            limit: '50-90 %',
            payment: '600-3000',
          },
          hospitalization: {
            limit: '40-100 %',
            payment: '9000-12000',
          },
          dentistry: {
            limit: '60-100 %',
            payment: '1500-3000',
          },
        },
      },
      {
        id: 41,
        listId: 16,
        sort: 4,
        type: '101-150 ₾',
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: '101-120 ₾/თვე',
          },
          en: {
            title: '101-120 ₾/mo',
          },
        },
        createdAt: '2023-10-27T13:44:35.448+04:00',
        updatedAt: '2023-10-27T13:44:35.448+04:00',
        title: '101-120 ₾',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. Lorem Ipsum has been that  industry’s standard  dummy text ever since the, when an unknown aren me of company printer took a galley.',
        services: {
          ambulatory: {
            limit: '60-100 %',
            payment: '900-4000',
          },
          medicines: {
            limit: '70-90 %',
            payment: '1000-3500',
          },
          hospitalization: {
            limit: '50-100 %',
            payment: '9000-15000',
          },
          dentistry: {
            limit: '60-100 %',
            payment: '1500-3500',
          },
        },
      },
      {
        id: 42,
        listId: 16,
        sort: 5,
        type: '101-150 ₾',
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: '121-130 ₾/თვე',
          },
          en: {
            title: '121-130 ₾/mo',
          },
        },
        createdAt: '2023-10-27T13:44:35.448+04:00',
        updatedAt: '2023-10-27T13:44:35.448+04:00',
        title: '121-130 ₾',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. Lorem Ipsum has been that  industry’s standard  dummy text ever since the, when an unknown aren me of company printer took a galley.',
        services: {
          ambulatory: {
            limit: '70-100 %',
            payment: '1000-4500',
          },
          medicines: {
            limit: '80-90 %',
            payment: '1000-4000',
          },
          hospitalization: {
            limit: '60-100 %',
            payment: '10000-18000',
          },
          dentistry: {
            limit: '60-100 %',
            payment: '2000-3500',
          },
        },
      },
      {
        id: 43,
        listId: 16,
        sort: 6,
        type: '101-150 ₾',
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: '131-150 ₾/თვე',
          },
          en: {
            title: '131-150 ₾/mo',
          },
        },
        createdAt: '2023-10-27T13:44:35.448+04:00',
        updatedAt: '2023-10-27T13:44:35.448+04:00',
        title: '131-150 ₾',
        body: 'Lorem Ipsum is simply dummy text of the printing and were  typesetting industry. Lorem Ipsum has been that  industry’s standard  dummy text ever since the, when an unknown aren me of company printer took a galley.',
        services: {
          ambulatory: {
            limit: '90-100 %',
            payment: '2000-5000',
          },
          medicines: {
            limit: '90-100 %',
            payment: '1000-5000',
          },
          hospitalization: {
            limit: '90-100 %',
            payment: '20000-25000',
          },
          dentistry: {
            limit: '90-100 %',
            payment: '1500-4000',
          },
        },
      },
    ],
  }
  //
  //
  const { filter, screenHeader } = useAppSelector((data: { health: HealthState }) => data.health)

  // start handle accordion opening

  // opened item array
  const [openedItemNumber, setOpenedItemNumber] = useState<number[] | []>([])
  //
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth)
  //
  const toggleAccordion = (index: number) => {
    // open && add new index in array
    if (index) {
      setOpenedItemNumber([...openedItemNumber, index])
    }
    // close && remove current index from array
    if (index && openedItemNumber.find((x) => x === index)) {
      setOpenedItemNumber([...openedItemNumber.filter((x) => x !== index)])
    }
  }
  //
  useEffect(() => {
    const handleResize = debounce(() => setScreenWidth(window.innerWidth), 100)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // end handle accordion opening

  //
  const [idsToHandle, setIdsToHandle] = useState<number[]>((filter.selectedPackageServices as number[]) || [])

  const handleCheckboxChange = (serviceId: any) => {
    setIdsToHandle((prevIds: number[]) => {
      if (prevIds.includes(serviceId)) {
        return prevIds.filter((id) => id !== serviceId)
      } else {
        return [...prevIds, serviceId]
      }
    })
  }

  useEffect(() => {
    dispatch(setSelectedPackageServices(idsToHandle))
  }, [idsToHandle, dispatch])
  //
  //
  const [pricesToHandle, setPricesToHandle] = useState<string[]>((filter.priceRanges as string[]) || [])

  const handlePriceChange = (priceId: any) => {
    setPricesToHandle((prevIds: string[]) => {
      setIdsToHandle([])
      if (prevIds.includes(priceId)) {
        return prevIds.filter((id) => id !== priceId)
      } else {
        return [priceId]
      }
    })
  }
  //set each type one time
  // @ts-ignore
  const prices = [...new Set(healthPackageServices?.listItems?.map((item) => item.type))]

  useEffect(() => {
    dispatch(setPriceRanges(pricesToHandle))
  }, [pricesToHandle, dispatch])

  let filteredItems = healthPackageServices?.listItems

  if (pricesToHandle.length) {
    filteredItems = healthPackageServices?.listItems?.filter((item) => pricesToHandle.includes(item.type))
  }

  //
  const pageTitle = filter?.selectedPackageServices?.length === 0 ? t('whichOne') : t('chooseToCompare')
  const stepName = healthPackageServices.translations[lang].stepName
  //
  const isHealthServicesLoading = false
  //
  const mainLoading = isHealthServicesLoading

  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <HealthProgressbar stepName={stepName} />

        <Text>{t('choosePriceRange')}</Text>
        <Prices>
          {prices.map((price, index) => (
            <Price
              $selected={pricesToHandle.includes(price) ? true : false}
              onClick={() => handlePriceChange(price)}
              key={index}
            >
              {price}
            </Price>
          ))}
        </Prices>

        <Block>
          {/* <Cards> */}
          {filteredItems.map((item, index) => {
            //
            const currentIndex = index + 1
            //
            return (
              <HorizontalCardStyle
                className="horizontal-card"
                key={item.id}
                disabled={false}
                title={item?.translations[lang].title}
                imgCHildren={<HealthServiceIconStyle />}
                selected={idsToHandle.includes(item.id) ? true : false}
                onClick={() => [handleCheckboxChange(item.id), toggleAccordion(currentIndex)]}
              >
                <ArrowBtn>
                  <ArrowStyle $open={openedItemNumber.find((x) => x === currentIndex) ? true : false} />
                </ArrowBtn>
                {screenWidth > 767 || openedItemNumber.find((x) => x === currentIndex) ? (
                  <DescriptionBlock className="horizontal-card-children">
                    <Line />
                    <UTitle>
                      <li></li>
                      <li>{t('healthLimit')}</li>
                      <li>{t('coPayment')}</li>
                    </UTitle>
                    <Ul>
                      <li>{t('ambulatory')}</li>
                      <li>{item.services?.ambulatory.limit}</li>
                      <li>{item.services?.ambulatory.payment} ₾</li>
                    </Ul>
                    <Ul>
                      <li>{t('medicines')}</li>
                      <li>{item.services?.medicines.limit}</li>
                      <li>{item.services?.medicines.payment} ₾</li>
                    </Ul>
                    <Ul>
                      <li>{t('hospitilazition')}</li>
                      <li>{item.services?.hospitalization.limit}</li>
                      <li>{item.services?.hospitalization.payment} ₾</li>
                    </Ul>
                    <Ul>
                      <li>{t('dentistry')}</li>
                      <li>{item.services?.dentistry.limit}</li>
                      <li>{item.services?.dentistry?.payment} ₾</li>
                    </Ul>
                  </DescriptionBlock>
                ) : null}
              </HorizontalCardStyle>
            )
          })}
          {/* </Cards> */}
          {filter?.selectedPackageServices?.length !== 0 && (
            <RemainingCompaniesStyle
              text={
                lang === 'ge'
                  ? `შეთავაზებების რაოდენობა ${3}`
                  : lang === 'en'
                  ? `${3} Companies are left with this options`
                  : ''
              }
            />
          )}
        </Block>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/category')} />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={filter.selectedPackageServices?.length !== 0 ? false : true}
            onClick={() => navigate('/health-priority')}
          />
        </Buttons>
      </Content>

      <BackgroundIcon shortKite={true} />
    </Wrapper>
  )
}

export default HealthCompareCompanies

//

const Wrapper = styled.div`
  background-color: ${Colors.backgroundGrey};
`
const Content = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 58px;
  padding-bottom: 120px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    padding-top: 26px;
    padding-bottom: 48px;
  }
`

const Text = styled.span`
  margin-top: 30px;
  margin-bottom: 20px;
  user-select: none;
  font-size: 18px;
  color: ${Colors.nevadaGrey};

  ${Responsive.mobile} {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 14px;
  }
`
const Prices = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 160px);
  gap: 12px;
  ${Responsive.mobile} {
    grid-template-columns: repeat(2, 140px);
  }
`

const Price = styled.div<{ $selected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  cursor: pointer;
  height: 50px;
  background-color: ${({ $selected }) => ($selected ? `${Colors.primaryBlack}` : `${Colors.grey}`)};
  border-radius: 25px;
  color: ${({ $selected }) => ($selected ? `${Colors.white}` : `${Colors.primaryBlack}`)};
  font-weight: ${({ $selected }) => ($selected ? '500' : 'normal')};
  font-size: 18px;

  ${Responsive.mobile} {
    font-size: 14px;
    height: 40px;
  }
`

const Block = styled.div`
  position: relative;
  margin-top: 40px;
  width: 100%;
  column-gap: 48px;
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(335px, 468px));

  ${Responsive.tablet} {
    column-gap: 28px;
  }

  ${Responsive.mobile} {
    column-gap: 20px;
    margin-top: 24px;
  }
`

// with minus margin top the remaining companies is exactly below the cards and
// the cards responsive is smooth. no matter how many cards will be there,
// remaining companies and cards are in the same vertical line.

const RemainingCompaniesStyle = styled(RemainingCompanies)`
  grid-row: 7;
  margin-top: -50px;

  ${Responsive.tablet} {
    margin-top: -20px;
  }

  ${Responsive.mobile} {
    margin-top: -12px;
  }
`

const HorizontalCardStyle = styled(HorizontalCard)`
  max-width: 468px;
  min-width: 335px;
  width: 100%;
  margin-bottom: 48px;

  ${Responsive.tablet} {
    margin-bottom: 28px;
  }

  ${Responsive.mobile} {
    margin-bottom: 20px;
  }

  div {
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;

    ${Responsive.mobile} {
      display: flex;
      justify-content: center;
      flex-direction: column;
      .horizontal-card {
        padding: 20px;
      }
    }
  }
  .horizontal-card-children {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`

const ArrowBtn = styled.button`
  position: absolute;
  top: 20px;
  left: 10px;
  display: none;
  padding: 10px;
  outline: none;
  border: none;
  background-color: transparent;
  ${Responsive.mobile} {
    display: flex;
  }
`
const ArrowStyle = styled(RightArrow)<{ $open: boolean }>`
  transform: ${({ $open }) => ($open === true ? 'rotate(-90deg)' : 'rotate(90deg)')};
  width: 15px;
  height: 15px;
`

const HealthServiceIconStyle = styled(HealthServiceIcon)`
  transform: rotate(-12deg);
`

const DescriptionBlock = styled.div`
  width: 100%;
  display: block;
`
const Line = styled.span`
  height: 1px;
  width: 100%;
  background-color: ${Colors.secondaryGrey};
  margin-block: 20px;
`

const UTitle = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  list-style: none;
  padding-left: unset;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;

  li {
    text-align: right;
  }
  ${Responsive.mobile} {
    grid-template-columns: 40% 23% 35%;
  }
`

const Ul = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  list-style: none;
  padding-left: unset;
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 13px;
  align-items: center;
  li {
    text-align: right;
    :first-child {
      text-align: left;
    }
  }
  ${Responsive.mobile} {
    grid-template-columns: 40% 23% 35%;
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 48px;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
